import { APIEncryptor } from 'app/runtime';
import axios from 'axios';
import aesUtil from 'utils/aesUtil';
import { ResultType } from './CommonDT';

// 接口请求真实IP

// 模拟器的宿主机地址
// export const bzBaseUrl = 'http://10.0.2.2:8080';
// export const payBaseUrl = 'http://10.0.2.2:8088';
// 本地回环地址
// export const bzBaseUrl = "http://127.0.0.1:8080";
// export const payBaseUrl = "http://127.0.0.1:8088";
// export const bzBaseUrlLocal = "http://127.0.0.1:8080";
// export const payBaseUrlLocal = "http://127.0.0.1:8088";
// 局域网本机地址
// https://192.168.50.2:8080/doc.html#/home
// http://192.168.50.2:8081/doc.html#/home

// 局域网本机地址
export const bizBaseUrlLocalLAN = 'http://192.168.31.60:8080';
export const webBaseUrlLocalLAN = 'http://192.168.31.60:3000';
// CF内网穿透地址
export const bizBaseUrlLocalNAT = 'https://dell-8080.uutt.me';
export const webBaseUrlLocalNAT = 'https://dell-3000.uutt.me';

// 测试地址
export const useNAT = true;
export const bizBaseUrlLocal = useNAT ? bizBaseUrlLocalNAT : bizBaseUrlLocalLAN;
export const webBaseUrlLocal = useNAT ? webBaseUrlLocalNAT : webBaseUrlLocalLAN;

// 公网地址
export const bizBaseUrl = 'https://api.uutt.me/ulost';
export const webBaseUrl = 'https://ulost.uutt.me';
// export const bzBaseUrl = bizBaseUrlLocal;
// export const webBaseUrl = webBaseUrlLocal;

// 支付地址（服务器部署V免签）
export const payBaseUrl = 'https://pay.uutt.me';
// 商户ID
export const merchantPid = '123456';
// 通讯密钥
export const merchantKey = 'b95fc22f02ab22dc8684af371a91ca23';

export const bzTimeout = 1000 * 30;
export const payTimeout = 1000 * 30;
export const defaultPageParams = {
  current: 1,
  pageSize: 18,
};

// Axios参考 https://www.axios-http.cn/docs/req_config
const getAxiosInstance = (local?: boolean) => {
  // 如果是本地接口，则不加密
  const _instance = axios.create({
    //应用接口
    baseURL: local ? bizBaseUrlLocal : bizBaseUrl,
    timeout: bzTimeout,
    // transformResponse 允许你在把响应数据传递给 then 或者 catch 之前对它们进行修改
    // 如果后端开启接口加密, 前端获取数据后要解密
    transformResponse: [
      (_data, headers, status) => {
        // if (APIEncryptor.enbledEncrypt && data != null && data !== undefined) {
        // axios 会自动解析 data, 如果指定transformResponse也需要解析
        let data: ResultType;
        let type: number;
        if (!local && APIEncryptor.enbledEncrypt && _data != null && _data !== undefined) {
          const realData: ResultType = JSON.parse(_data);
          if (realData.msg != null) {
            realData.msg = aesUtil.decrypt(realData.msg, false);
            type = 1;
          }
          if (realData.result != null) {
            realData.result = aesUtil.decryptObj(realData.result, false);
            type = 2;
          }
          data = realData;
        } else {
          data = JSON.parse(_data);
          type = 3;
        }
        // console.warn("transformResponse:" + type, data, _data, headers, status);
        return data;
      },
    ],
    // 在将请求数据发送到服务器之前对其进行修改，这只适用于请求方法 put、post 和 patch
    transformRequest: [
      (_data, headers) => {
        let data: string;
        let type: number;
        if (
          !local &&
          APIEncryptor.enbledDecrypt &&
          _data != null &&
          _data !== undefined &&
          headers['Content-Type'] === 'application/json'
        ) {
          data = aesUtil.encryptObj(_data, false);
          type = 1;
        } else {
          data = JSON.stringify(_data);
          type = 2;
        }
        // console.warn("transformRequest: " + type, data, _data, headers);
        return data;
      },
    ],
  });
  return _instance;
};

const _instance = getAxiosInstance(false);

export const _req = (url: string, method: string, params?: {}, data?: {}) => {
  return new Promise<ResultType>((resolve, _reject) => {
    _instance
      .request({
        url: url,
        method: method,
        params: params,
        data: data,
        headers: {
          'Content-Type': 'application/json', //axios会默认会将data序列化为json串
        },
      })
      // 请求成功(res.code==200)
      .then((res) => {
        // message.info("请求成功");
        resolve(res.data as ResultType);
      })
      //请求失败
      .catch((error) => {
        console.log('[请求错误]\nurl:' + url + '\nerr:' + error);
        // message.info("网络错误");
        // reject(error); //向上抛出错误
      });
  });
};

export const _get = (path: string, id: String) => {
  return new Promise<ResultType>((resolve, _reject) => {
    _instance
      .request({
        url: path + id,
        method: 'get',
      })
      // 请求成功(res.code==200)
      .then((res) => {
        // message.info("请求成功");
        resolve(res.data as ResultType);
      })
      //请求失败
      .catch((error) => {
        console.log('[请求错误]\nurl:' + path + '\nerr:' + error);
        // message.info("网络错误");
        // reject(error); //向上抛出错误
      });
  });
};

//兼容save和batchSave
export const _post = (path: string, data?: {}) => {
  return new Promise<ResultType>((resolve, reject) => {
    _instance
      .request({
        url: path,
        method: 'post',
        data: data,
        headers: {
          'Content-Type': 'application/json', //axios会默认会将data序列化为json串
        },
      })
      // 请求成功(res.code==200)
      .then((res) => {
        // message.info("请求成功");
        resolve(res.data as ResultType);
      })
      //请求失败
      .catch((error) => {
        console.log('[请求错误]\nurl:' + path + '\nerr:' + error);
        // message.info("网络错误");
        // reject(error); //向上抛出错误
      });
  });
};

//兼容update和batchupdate
export const _put = (path: string, data: {}) => {
  return new Promise<ResultType>((resolve, reject) => {
    _instance
      .request({
        url: path,
        method: 'put',
        data: data,
        headers: {
          'Content-Type': 'application/json', //axios会默认会将data序列化为json串
        },
      })
      // 请求成功(res.code==200)
      .then((res) => {
        // message.info("请求成功");
        resolve(res.data as ResultType);
      })
      //请求失败
      .catch((error) => {
        console.log('[请求错误]\nurl:' + path + '\nerr:' + error);
        // message.info("网络错误");
        // reject(error); //向上抛出错误
      });
  });
};

//默认batchremove
export const _delete = (path: string, ids: string[]) => {
  return new Promise<ResultType>((resolve, reject) => {
    _instance
      .request({
        url: path,
        method: 'delete',
        data: ids,
        headers: {
          'Content-Type': 'application/json', //axios会默认会将data序列化为json串
        },
      })
      // 请求成功(res.code==200)
      .then((res) => {
        // message.info("请求成功");
        resolve(res.data as ResultType);
      })
      //请求失败
      .catch((error) => {
        console.log('[请求错误]\nurl:' + path + '\nerr:' + error);
        // message.info("网络错误");
        // reject(error); //向上抛出错误
      });
  });
};

const _instanceLocal = getAxiosInstance(true);
export const _reqLocal = (url: string, method: string, params?: {}, data?: {}) => {
  return new Promise<ResultType>((resolve, _reject) => {
    _instanceLocal
      .request({
        url: url,
        method: method,
        params: params,
        data: data,
        headers: {
          'Content-Type': 'application/json', //axios会默认会将data序列化为json串
        },
      })
      // 请求成功(res.code==200)
      .then((res) => {
        // message.info("请求成功");
        resolve(res.data as ResultType);
      })
      //请求失败
      .catch((error) => {
        console.log('[请求错误]\nurl:' + url + '\nerr:' + error);
        // message.info("网络错误");
        // reject(error); //向上抛出错误
      });
  });
};
